<template>
  <div class="menu-wrap">
    <div class="mask-wrap" v-if="menuStatus" @click="handleMenu"></div>
    <div class="menu" :class="menuStatus ? 'active' : ''">
      <div class="menu-item no-bg"></div>
      <div class="menu-item">
        <span @click="doRouter('/home')">首页</span>
        <span class="menu-item-en" @click="doRouter('/home')">Home page</span>
      </div>
      <div class="about">
        <div class="menu-item">
          <span @click.stop="doRouter('/about-us')">关于我们</span>
          <span class="menu-item-en"  @click.stop="doRouter('/about-us')">About us</span>
        </div>
        <div class="hide-item">
          <div class="menu-item">
            <span @click="doRouter('/about-us', 'company')">公司简介</span>
            <span class="menu-item-en"></span>
          </div>
          <div class="menu-item">
            <span @click="doRouter('/about-us', 'author')">作家简介</span>
            <span class="menu-item-en" @click="doRouter('/about-us', 'author')"></span>
          </div>
        </div>
      </div>
      <div class="menu-item">
        <span @click="doRouter('/company-news')">公司动态</span>
        <span class="menu-item-en" @click="doRouter('/company-news')">Company news</span>
      </div>
      <div class="menu-item">
        <span @click="doRouter('/project-introduction')">项目介绍</span>
        <span class="menu-item-en"  @click="doRouter('/project-introduction')">Project introduction</span>
      </div>
      <div class="menu-item">
        <span @click="doRouter('/world-view')">世界观</span>
        <span @click="doRouter('/world-view')" class="menu-item-en">World view</span>
      </div>
      <div class="menu-item">
        <span @click="doRouter('/contact-us')">联系我们</span>
        <span class="menu-item-en" @click="doRouter('contact-us')">Contact us</span>
      </div>
      <!-- <div class="menu-item">
        <span @click="doRouter('/live')">Live</span>
        <span class="menu-item-en" @click="doRouter('/live')">Live</span>
      </div> -->
    </div>
    <div class="menu-active" @click="handleMenu">
      <i class="iconfont icon-close" v-if="menuStatus"></i>
      <i class="iconfont icon-menu" v-else></i>
    </div>
    <div class="logo" @click="doRouter('/home')"></div>
  </div>
</template>

<script>
export default {
  data: _ => ({
    menuStatus: false
  }),
  methods: {
    handleMenu () {
      this.menuStatus = !this.menuStatus
    },
    doRouter (path, hash) {
      this.menuStatus = false
      path = hash ? `${path}#${hash}` : path
      this.$router.push({ path })
    }
  }
}
</script>

<style lang="scss" scoped>
.mask-wrap{
  position: fixed;
  top:0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 20;
  background: #000;
  opacity: .5;
}
.menu {
  width: 390px;
  height: 100vh;
  background: #fff;
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  transition: width 0.4s;
  overflow: hidden;
  z-index: 21;
  &.active {
    width: 390px;
  }
  .menu-item {
    &.no-bg:hover{
      background: #fff;
    }
    height: 102px;
    box-sizing: border-box;
    border-bottom: 1px solid #dbdbdb;
    padding: 0 60px;
    font-size: 18px;
    line-height: 100px;
    font-weight: bold;
    color: #8e8e8e;
    display: flex;
    justify-content: space-between;
    &:hover{
      background: #272b37;
      color: #9F896B;
      .menu-item-en {
        color: #fefefe;
      }
    }
    >span{
      cursor: pointer;
    }
    .menu-item-en {
      color: #9a9a9a;
      font-size: 12px;
    }
  }
  .hide-item{
    transition: height .5s;
    height: 0;
    overflow: hidden;
  }

  .about{
    &:hover{
      .menu-item {
        background: #272b37;
        color: #9F896B;
        border-bottom: 1px solid rgba(219,219,219,.3);
        .menu-item-en {
          color: #fefefe;
        }
      }
      .hide-item{
        .menu-item{
          color:rgba(254,254,254,.7);
        }
        height: 204px;
      }
    }
    .hide-item{
        .menu-item{
          &:hover{
            color:#9F896B;
          }
        }
    }
  }
}

.menu-active {
  position: absolute;
  top: 46px;
  right: 58px;
  z-index: 21;
  >i {
    width: 26px;
    height: 26px;
    cursor: pointer;
  }
  .icon-close{
    color: #000;
  }
  .icon-menu{
    color: #b6b6b6;
    &:hover{
      color: #fff;
    }
  }
}
.logo{
    position: absolute;
    top: 3rem;
    left: 3rem;
    width: 10rem;
    height: 3.1rem;
    background: url(/static/img/logo.png);
    background-size: 100% 100%;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue